'use client';

import { StarRating, Text } from '@galapagos/design-system/web';
import { sizing } from '@galapagos/design-system/sizing';
import { useTranslation } from 'react-i18next';

/** The App Store rating the card shows; the `download.rating.score` copy states the same number. */
export const APP_STORE_RATING = 4.5;

/** A row of stars filled to `value`, drawn for looks only; the text beside it carries the rating. */
export function StarRow({ value }: { value: number }) {
  return <StarRating decorative value={value} iconSize={sizing.icon.xs} />;
}

/** The App Store rating card above the member reviews. */
export function RatingSummary() {
  const { t } = useTranslation('signup');
  return (
    <section
      className="signup-download__card signup-download__card--muted signup-download__rating"
      aria-label={t('download.rating.label')}
      data-testid="signup-download-rating"
    >
      <p className="signup-download__rating-score">{t('download.rating.score')}</p>
      <div className="signup-download__rating-text">
        <span className="signup-download__rating-line">
          <StarRow value={APP_STORE_RATING} />
          <Text variant="b3Bold" value={t('download.rating.outOf')} />
        </span>
        <Text variant="c1Regular" color="secondary" value={t('download.rating.count')} />
      </div>
    </section>
  );
}
